module.exports = __webpack_public_path__ + "static/media/arrow.a1ec8f16.svg";